import { type Ref, useMemo } from "react";

import { mergeRefs } from "@/utils/merge-refs";

export function useMergedRefs<T>(
  ...refs: Array<Ref<T> | undefined | null>
): (instance: T | null) => void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mergeRefs<T>(refs), refs);
}
